import { getResolvedPath } from '../../../util/routing/entity-paths';

export const BALANCE_SHEET_BASE_PATH = getResolvedPath('/clearing/finance/accounting/balance-sheet');
